export default __webpack_public_path__ + "static/media/Transporter Management.29cbe754.svg";